module.exports = __webpack_public_path__ + "img/P150T_weapon_71.efbd718b.png";